module.exports = __webpack_public_path__ + "static/media/osintion.7ed83d9a.png";